// Owner: account-settings (plan §9.3). Account › Keyboard shortcuts.
import { createFileRoute } from '@tanstack/react-router';
import { ShortcutsPage } from '../../../features/account/ShortcutsPage';

export const Route = createFileRoute('/_settings/account/shortcuts')({
  component: ShortcutsPage,
});
